import React from 'react';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {base16AteliersulphurpoolLight} from 'react-syntax-highlighter/dist/esm/styles/prism';
import {
    Box,
    Button,
    Typography,
    Paper,
} from "@material-ui/core";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const ParseResponse = ({data}) => {
    let isJSON;
    let parseBody = false;
    let rawBody = false;
    try {
        isJSON = JSON.parse(data);
    } catch (e) {
        isJSON = false;
        const newData = data.split('\n');
        rawBody = newData.find(el => el.includes('BODY='));
        if (rawBody) {
            const newBody = rawBody.split('BODY=');
            if (newData.includes('Content-Type = [application/x-www-form-urlencoded]')) {
                parseBody = Array.from(new URLSearchParams(newBody[1]).entries()).reduce((a, [k, v]) => ((a[k] = v, a)), {});
            } else if (newData.includes('Content-Type = [application/json]')) {
                parseBody = JSON.parse(newBody[1]);
            }
        }
    }

    const prettifyXml = (xml, tab) => { // tab = optional indent value, default is tab (\t)
        var formatted = '', indent = '';
        tab = tab || '\t';
        xml.split(/>\s*</).forEach(function (node) {
            if (node.match(/^\/\w/)) indent = indent.substring(tab.length); // decrease indent by one 'tab'
            formatted += indent + '<' + node + '>\r\n';
            if (node.match(/^<?\w[^>]*[^\/]$/)) indent += tab;              // increase indent
        });
        return formatted.substring(1, formatted.length - 3);
    }

    const renderCopyButton = () => (
        <CopyToClipboard text={data}>
            <Box display="flex" style={{marginBottom: '10px'}}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<FileCopyIcon/>}
                >
                    Copy Raw
                </Button>
            </Box>
        </CopyToClipboard>
    );

    /**
     * JSON Data
     */
    if (isJSON) {
        return (
            <>
                {renderCopyButton()}
                <Paper>
                    <SyntaxHighlighter language="json" style={base16AteliersulphurpoolLight}>
                        {JSON.stringify(isJSON, null, 2)}
                    </SyntaxHighlighter>
                </Paper>
            </>
        );
    }
    /**
     * XML Data
     */
    return (
        <>
            {renderCopyButton()}
            <Paper>
                {parseBody ? (
                    <>
                        <Typography variant="h6" align="left" style={{margin: '15px 10px 10px'}}>Raw
                            Request</Typography>
                        <SyntaxHighlighter language="xml" style={base16AteliersulphurpoolLight}>
                            {prettifyXml(data)}
                        </SyntaxHighlighter>
                        <Typography variant="h6" align="left" style={{marginLeft: '10px'}}>Body (Convert to
                            JSON)</Typography>
                        <SyntaxHighlighter language="json" style={base16AteliersulphurpoolLight}>
                            {JSON.stringify(parseBody, null, 2)}
                        </SyntaxHighlighter>
                    </>
                ) : (
                    <>
                        <SyntaxHighlighter language="xml" style={base16AteliersulphurpoolLight}>
                            {prettifyXml(data)}
                        </SyntaxHighlighter>
                    </>
                )}
            </Paper>
        </>
    );
};

export default ParseResponse;